import { IonContent, IonLoading, IonPage, IonToast } from "@ionic/react";
import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "../util/AppInsights";
import {
  TranslationMessagesContext,
  TranslationsContext,
} from "../util/Translations";
import { useContext } from "react";
import { useLocation, useParams } from "react-router";
import PageHeader from "../components/PageHeader";
import { maxResults, useQueryExec } from "../hooks/useQueryExec";
import QueryFilter from "../components/QueryFilter";
import QueryResults from "../components/QueryResults";
import { decodeParam } from "../util/ApiHelper";

const Requisitions: React.FC = () => {
  const { translations } = useContext(TranslationsContext);
  const { translatedMessages } = useContext(TranslationMessagesContext);
  let showBack = useLocation().pathname.includes("/Stores/Requisitions");
  const {
    getQueryList,
    queryList,
    getFilterParams,
    filterParams,
    setParameter,
    queryRows,
    executeSearch,
    errorState,
    totalCount,
    queryCriteria,
    getQueryCriteria,
    getNoOfFieldsToDisplay,
    showLoading,
    setShowLoading,
    showToast,
    setShowToast,
    searchYn,
    setSearchYn,
    queryName,
    criteriaParams,
    confirmSearch,
    execFilter,
    resultsFilter,
    filterRows,
  } = useQueryExec(
    "Requisition",
    "Requisition",
    "requisition",
    undefined,
    true
  );

  const querySection = "QW--Requisition";
  const { storesTab } = useParams<{ storesTab: string }>();
  let storesValue = decodeParam(storesTab);

  return (
    <IonPage>
      <PageHeader
        title={translations["lbl_reqs"] || "Requisitions"}
        showBack={showBack}
      ></PageHeader>
      <IonLoading
        cssClass="my-custom-class"
        isOpen={showLoading}
        onDidDismiss={() => setShowLoading(false)}
        duration={2000}
      />
      <IonToast
        isOpen={showToast}
        onDidDismiss={() => setShowToast(false)}
        message={
          translatedMessages["DisplayFirst"]?.MessageText.replace(
            "@1",
            maxResults
          )
            .replace("@2", translations["lbl_reqs"] || "requisitions")
            .replace("@3", totalCount) ||
          `Displaying the first ${maxResults} requisitions of ${totalCount}.`
        }
        duration={2000}
        position="top"
      />
      <IonContent>
        <QueryFilter
          setShowLoading={setShowLoading}
          getQueryList={getQueryList}
          queryList={queryList}
          querySection={querySection}
          getFilterParams={getFilterParams}
          filterParams={filterParams}
          setParameter={setParameter}
          queryCriteria={queryCriteria}
          getQueryCriteria={getQueryCriteria}
          searchCallback={confirmSearch}
        />
        <QueryResults
          searchYn={searchYn}
          setSearchYn={setSearchYn}
          queryName={queryName}
          queryParams={filterParams}
          criteria={criteriaParams}
          queryRows={queryRows}
          filterParams={filterParams}
          setParameter={setParameter}
          executeSearch={executeSearch}
          getNoOfFieldsToDisplay={getNoOfFieldsToDisplay}
          errorState={errorState}
          totalCount={totalCount}
          showLoading={showLoading}
          setShowLoading={setShowLoading}
          cardLink={`/Stores/Requisitions/replaceWithValue/${storesValue}`}
          filterRows={filterRows}
          filterMethod={execFilter}
          filterString={resultsFilter}
        />
      </IonContent>
    </IonPage>
  );
};

export default withAITracking(reactPlugin, Requisitions, "Requisitions");
